<template>
  
  <div id="modal">
    <div class="container-fluid">
      <p class="linespace95"></p>

      <div class="row">
        <div class="col-12">
          <div class="centertext">
	    <p class="linespace45"></p>
	    <p class="linespace65"></p>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col"> </div>
          <div class="col-auto"> 
            <div class="container-fluid">
              <div class="row">
                <div class="col-5">
                  <div class="text-right" style="height:20px;">System User</div>
                </div>
                <div class="col-7">
                  <div class="flindexitem02"><input type="text" placeholder="ID" v-model="user_id"></div>
                </div>
              </div>
            </div>
            <p class="linespace10"></p>
            <div class="container-fluid">
              <div class="row">
                <div class="col-5">
                  <div class="text-right" style="height:20px;">Password</div>
                </div>
                <div class="col-7">
                  <div class="flindexitem02"><input type="password" placeholder="パスワード" v-model="pass"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col"> </div>
        </div>
      </div>
      <p class="linespace30"></p>
      <div class="row">
	<div class="col-12" style="display: flex">
          <div class="centerbox">
            <button type="button" class="loginBtn" @click="login">Login</button>
          </div>
	</div>
      </div>
      <p class="linespace10"></p>
      <div class="row">
	<div class="col-12" style="display: flex; justify-content: center">
	  Ver.1.0.0
	</div>
      </div>

      <p class="linespace45"></p>
      <p class="linespace65"></p>

    </div>
  </div>

  <ErrorDialog />
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import router from '../router';
import { checkMaintenance, doLogin } from '../server';
import { error } from './ErrorDialog.vue';

checkMaintenance();

const user_id = ref('');
const pass    = ref('');

const login = async () => {
    if (!user_id.value) {
	error('missing user_id');
	return;
    }
    if (!pass.value) {
	error('missing password');
	return;
    }
    try {
	const res = await doLogin(user_id.value, pass.value);
	if (res.result == 'success') {
	    router.push({ name: 'Menu' });
	} else {
	    error(res.message);
	}
    }
    catch(e) {
	console.log(e)
    }
};
  
</script>


<style scoped>
.app {
  font-size: 40px;
    color: blue;
}
</style>
